module.exports = __webpack_public_path__ + "img/qxxh.0754bf05.png";